import React from 'react'
import ImportTab from './ImportTab'
import FinalTab from './FinalTab'
import Errors from './Errors'
import { useImportStore } from '../../../stores/importStore'
import Icon from '../../components/Icon'

const Import: React.FC = () => {
  const {
    activeTab,
    setActiveTab,
    errors,
    setErrors,
    importedData,
    setImportedData,
    clearAllStudents,
  } = useImportStore()

  const clearImportedData = () => {
    if (importedData.length > 0) {
      const confirmed = window.confirm(
        `Are you sure you want to clear all ${importedData.length} imported records? This action cannot be undone.`,
      )
      if (confirmed) {
        clearAllStudents()
      }
    }
  }

  const tabs = [
    { id: 'import', label: 'Import' },
    { id: 'final', label: 'Review' },
    { id: 'errors', label: 'Errors' },
  ]

  return (
    <div>
      <div className="flex justify-between items-center mb-6">
        <h1 className="text-2xl font-bold text-gray-900">Import</h1>
        {importedData.length > 0 && (
          <button
            onClick={clearImportedData}
            className="bg-red-600 text-white px-4 py-2 rounded-md hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-red-500 focus:ring-offset-2 flex items-center gap-2"
          >
            <Icon type="trash" className="h-4 w-4" />
            Clear Students ({importedData.length})
          </button>
        )}
      </div>
      <div className="bg-white shadow rounded-lg p-6">
        <div id="tabs">
          {/* Tab Navigation */}
          <div className="border-b border-gray-200">
            <nav className="-mb-px flex space-x-8">
              {tabs.map((tab) => (
                <button
                  key={tab.id}
                  onClick={() => setActiveTab(tab.id)}
                  className={`py-2 px-1 border-b-2 font-medium text-sm whitespace-nowrap ${
                    activeTab === tab.id
                      ? 'border-blue-500 text-blue-600'
                      : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
                  }`}
                >
                  {tab.label}
                  {tab.id === 'final' && importedData.length > 0 && (
                    <span className="ml-1">({importedData.length})</span>
                  )}
                  {tab.id === 'errors' && errors.length > 0 && (
                    <span className="ml-1 bg-red-100 text-red-800 text-xs px-2 py-1 rounded-full">
                      {errors.length}
                    </span>
                  )}
                </button>
              ))}
            </nav>
          </div>

          {/* Tab Content */}
          <div className="mt-6">
            {activeTab === 'import' && (
              <ImportTab
                errors={errors}
                setImportedData={setImportedData}
                setActiveTab={setActiveTab}
                importedData={importedData}
              />
            )}

            {activeTab === 'errors' && (
              <Errors errors={errors} setActiveTab={setActiveTab} />
            )}

            {activeTab === 'final' && (
              <FinalTab
                importedData={importedData}
                setActiveTab={setActiveTab}
                setErrors={setErrors}
                clearAllStudents={clearAllStudents}
              />
            )}
          </div>
        </div>
      </div>
    </div>
  )
}

export default Import
